/**
 * @license
 * @copyright Copyright Motili Inc., 2017 All Rights Reserved
 */

import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';

import { FileInput } from '@motili/ui';
import styled from 'styled-components';
import Config from '../../../Config';
import { generateRandomUUID } from '../../utils/Utils';
import styles from './FileUploadDropzone.module.scss';
import MotiliButton from '../../components-v2/buttons/MotiliButton';

export function getNotApplicationFiles() {
    return [
        {
            preview: Config.notApplicablePhoto.url,
            name: generateRandomUUID(),
            type: Config.notApplicablePhoto.type,
        },
    ];
}

export default class FileUploadDropZone extends Component {
    static propTypes = {
        accept: PropTypes.shape({
            'image/jpeg': PropTypes.arrayOf(PropTypes.string),
            'image/png': PropTypes.arrayOf(PropTypes.string),
            'application/pdf': PropTypes.arrayOf(PropTypes.string),
        }),
        disabled: PropTypes.bool,
        multiple: PropTypes.bool,
        acls: PropTypes.bool,
        handleOnDrop: PropTypes.func.isRequired,
        enableNotApplicablePhoto: PropTypes.bool,
        handleOnClick: PropTypes.func,
        readOnly: PropTypes.bool,
    };

    static defaultProps = {
        accept: {
            'image/jpeg': [],
            'image/png': [],
            'application/pdf': [],
        },
        disabled: false,
        multiple: true,
        acls: false,
        enableNotApplicablePhoto: false,
    };

    constructor(props) {
        super(props);
        this.dropzoneRef = createRef();
    }

    render() {
        const fileDropZone = this;

        return (
            <>
                {this.props.readOnly ? (
                    <StyledDropzone>
                        <StyledContent>
                            <StyledCloudIcon className='fa fa-cloud-upload' />
                            <h4>{`Drag and Drop ${
                                this.props.multiple ? 'Files' : 'a File'
                            } Here`}</h4>
                            or click to select a file to upload
                        </StyledContent>
                    </StyledDropzone>
                ) : (
                    <FileInput
                        id='dropzone'
                        accept={this.props.accept}
                        className={`${styles.container}${
                            !this.props.acls || this.props.disabled
                                ? ` ${styles.disabled}`
                                : ''
                        }`}
                        disabled={!this.props.acls || this.props.disabled}
                        multiple={this.props.multiple}
                        onDrop={(acceptedFiles, rejectedFiles) => {
                            const _acceptedFiles = acceptedFiles?.map(file =>
                                Object.assign(file, {
                                    preview: URL.createObjectURL(file),
                                })
                            );
                            const _rejectedFiles = rejectedFiles?.map(
                                rejectedFile =>
                                    Object.assign(rejectedFile, {
                                        preview: URL.createObjectURL(
                                            rejectedFile.file
                                        ),
                                    })
                            );
                            this.props.handleOnDrop(
                                _acceptedFiles,
                                _rejectedFiles
                            );
                        }}
                    />
                )}
                {fileDropZone.props.enableNotApplicablePhoto && (
                    <div className={styles['not-applicable-container']}>
                        <em
                            className={
                                !(!this.props.acls || this.props.disabled)
                                    ? styles['blue-hyper-link']
                                    : `${styles.disabled}`
                            }
                            onClick={() => {
                                if (!(!this.props.acls || this.props.disabled))
                                    fileDropZone.props.handleOnDrop(
                                        getNotApplicationFiles(),
                                        []
                                    );
                            }}
                        >
                            Click here{' '}
                        </em>
                        <span>if Photo Requirement is Not Applicable</span>
                    </div>
                )}
            </>
        );
    }
}

export class FileUploadButton extends Component {
    static propTypes = {
        accept: PropTypes.string,
        disabled: PropTypes.bool,
        multiple: PropTypes.bool,
        acls: PropTypes.bool,
        text: PropTypes.string,
        handleOnDrop: PropTypes.func.isRequired,
    };

    static defaultProps = {
        accept: 'image/jpeg, image/png, application/pdf',
        disabled: false,
        multiple: true,
        acls: false,
    };

    render() {
        let dropzoneRef;
        return (
            <div>
                <Dropzone
                    id='upload-button'
                    ref={node => {
                        dropzoneRef = node;
                    }}
                    accept={this.props.accept}
                    onDrop={(acceptedFiles, rejectedFiles) =>
                        this.props.handleOnDrop(acceptedFiles, rejectedFiles)
                    }
                    disabled={!this.props.acls || this.props.disabled}
                    multiple={this.props.multiple}
                    noClick
                    style={{
                        width: '0px',
                        height: '0px',
                        border: 'none',
                    }}
                />
                <MotiliButton
                    text={this.props.text}
                    moStyle='normal'
                    disabled={this.props.disabled}
                    onClick={e => {
                        e.stopPropagation();
                        dropzoneRef.open();
                    }}
                />
            </div>
        );
    }
}

const StyledDropzone = styled.div`
    width: 100%;
    height: 200px;
    border-width: 2px;
    border-color: #818181;
    border-style: dashed;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: no-drop;
`;

const StyledContent = styled.div`
    text-align: center;
    color: #818181;
`;

const StyledCloudIcon = styled.i`
    color: #818181;
    font-size: 75px;
`;
